import { useTranslation } from "next-i18next";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import dynamic from "next/dynamic";
import { useLaserBlastPageViews } from "@looksrare/classic-games/laser-blast";
import { getCanonicalAndLanguageAlternates, getChainInfo } from "@/utils";
import { Page } from "@/components";
import { LaserBlastGameProvider } from "@/components/YoloGamesLaserBlastProvider";

const LaserBlastMainView = dynamic(
  () => import("@looksrare/classic-games/laser-blast/LaserBlastMainView").then((module) => module.LaserBlastMainView),
  {
    ssr: false,
  }
);

const LaserBlastPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  // Ensure that the page view is tracked
  useLaserBlastPageViews();

  const title = "LaserBlast";
  const description = t("Invaders must die.");
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/laser-blast/",
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={t("LaserBlast")} contentContainerProps={{ px: 4, py: 4 }}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/laser-blast/meta.png`,
              alt: "LaserBlast",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <LaserBlastGameProvider>
        <LaserBlastMainView />
      </LaserBlastGameProvider>
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["laser", "common", "localization"])),
    },
  };
};

export default LaserBlastPage;
